import { AlertResponse } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

export interface MaintenanceCountQuery{
    group_by?:string,
    service_date?:string,
    embossment_number?:string
    donor_id?:string
    serial_number?:string
    schedule_status?:string
    asset_id?:string
    asset_category?:string

}
const getMaintenanceCount = async (
    queryParams:MaintenanceCountQuery

) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<Record<string,number>>(
    "get",
    `asset-maintenance-schedules/analytics/count${query}`
  );
};

const getMaintenanceAlert = async () => {
  return apiService.apiRequest<AlertResponse>(
    "get",
    `asset-maintenance-schedules/analytics/maintenance`
  );
};
export const maintemanceSchedulesAnalytics= {
    getMaintenanceCount,
    getMaintenanceAlert
}